import CloseIcon from "@mui/icons-material/Close";
import {
  Backdrop,
  Box,
  IconButton,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import { NotificationsList } from "Components/Shared/Notification/NotificationsList";
import { NotificationsControls } from "Components/Layout/UserHeader/Notifications/NotificationsControls";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.UserMenu.Notifications;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  anchorEl: HTMLElement | null;
  notificationsCount: number;
};

export const NotificationsPopover = ({
  isOpen,
  onClose,
  anchorEl,
  notificationsCount,
}: Props) => {
  const { t } = useResource();

  return (
    <>
      <Backdrop
        open={isOpen}
        onClick={onClose}
        sx={{
          zIndex: ({ zIndex }) => zIndex.modal - 1,
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0, 0, 0, 0.1)",
        }}
      />
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{
          paper: {
            sx: {
              mt: 3,
              minWidth: 280,
              minHeight: 207, //matches the height when there is no notifications message
              width: ["calc(100% - 32px)", "500px"],
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              borderRadius: 2,
              zIndex: (theme) => theme.zIndex.modal,
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
            },
          },
        }}
      >
        <Stack borderRadius={2} flex={1}>
          <Box
            p={3}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6">{t(RESOURCES.Title)}</Typography>
            <IconButton onClick={onClose} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Stack justifyContent="space-between" flex={1}>
            <Box pl={3} pb={3}>
              <NotificationsList isInPopup />
            </Box>
            <NotificationsControls
              onRequestPopupClose={onClose}
              isBulkDeleteEnabled={notificationsCount > 0}
            />
          </Stack>
        </Stack>
      </Popover>
    </>
  );
};
